import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = (n) => (_pushScopeId("data-v-3ec49866"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "service-row" };
const _hoisted_2 = { class: "service-number" };
const _hoisted_3 = { class: "service-copy" };
const _hoisted_4 = { class: "service-tag" };
export default /*#__PURE__*/ _defineComponent({
    __name: 'ServiceCard',
    props: {
        number: {},
        title: {},
        description: {},
        tag: {}
    },
    setup(__props) {
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("article", _hoisted_1, [
                _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.number), 1),
                _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.tag), 1),
                    _createElementVNode("h3", null, _toDisplayString(_ctx.title), 1),
                    _createElementVNode("p", null, _toDisplayString(_ctx.description), 1)
                ])
            ]));
        };
    }
});
